import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor(
        $q,
        $state,
        $uibModal,
        Alert,
        HardTokenEditModal,
        HardTokenService,
        HardTokenResource,
        UsersResource,
        ConfirmDeleteModal
    ) {
        this.$q = $q;
        this.$state = $state;

        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.HardTokenEditModal = HardTokenEditModal;
        this.HardTokenService = HardTokenService;
        this.HardTokenResource = HardTokenResource;
        this.UsersResource = UsersResource;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
    }

    $onInit() {
        this.stAccounts = new SmartTable();
        this.stDevices = new SmartTable();
        this.stSharedServiceAccounts = new SmartTable();
        this.stSharedNotes= new SmartTable();
        this.emailAccounts = this.accountsForCompanyUser.filter(a => a.status === 'ACTIVE');
        this.notificationEmailAccount = this.emailAccounts
            .find((account) => account.username === this.companyUser.userIdentifyingName);
        this.isSmsUser = this.companyUser.saaspassUser.userType === 'SMS_USER';
        this.isRoleEditable =
            this.companyUser.blocked === 'NONE'
            && this.emailAccounts.length
            && this.companyUser.saaspassUser.saaspassId !== this.account.login;
        this.initializeUserStatusFlags();
    }

    initializeUserStatusFlags() {
        this.isBlocked = this.companyUser.blocked != 'NONE';
        this.isPaused = this.companyUser.status == 'PAUSED';
        this.isActive = this.companyUser.status == 'ACTIVE';
    }

    getSharingTypeDisplayName(sharingType) {
        if (sharingType == 'INDIVIDUAL_AND_TEAM') {
            return 'INDIVIDUAL & TEAM';
        } else {
            return sharingType;
        }
    }
    
	allowGenerateBackupCodes(){
		return  this.companyUser.id && !this.isSmsUser && this.userSettings.backupCodesEnabled;
	}

    disableSmsUsage() {
        this.$uibModal
            .open({
                component: 'companyUserDirectoriesManageUserDetailsDeactivateSms',
                resolve: {
                    companyId: () => this.companyId,
                    companyUserId: () => this.companyUser.id,
                },
            }).result
            .then(() => {
                this.companyUser.smsUsageApproved = false;
                this.Alert('success', 'company.user-directories.manage-user.sms-usage-disabled');
            })
    }

    editRole() {
        if (this.companyUser.roleType === 'END_USER') {
            this.$state.go('company.administrators.add', {email: this.emailAccounts[0].username});
        } else {
            this.$state.go('company.administrators.edit', {companyUserId: this.companyUser.id});
        }
    }

    enableSmsUsage() {
        this.isEnablingSmsUsage = true;
        this.UsersResource
            .activateSmsUsageForCompanyUser(this.companyId, this.companyUser.id)
            .then(() => {
                this.companyUser.smsUsageApproved = true;
                this.Alert('success', 'company.user-directories.manage-user.sms-usage-enabled');
            })
            .finally(() => this.isEnablingSmsUsage = false)
    }

    showAssignModal() {
        this.$uibModal.open({
            component: 'companyUserDirectoriesManageUserDetailsAssignHardToken',
            size: 'xl',
            resolve: {companyUser: () => this.companyUser,hardTokens,companyId:()=>this.companyId},
        })
    }

    unAssingTokenSecondary(tokenId){
        this.HardTokenResource
            .unAssingTokenAsSecondary(this.companyId,this.companyUser.id,tokenId)
            .then((data) => {
                this.devicesForCompanyUser.splice( this.devicesForCompanyUser.findIndex(t=>t.deviceId===tokenId), 1 );
                this.Alert('success', 'company.user-directories.manage-user.device_unassigned');
            })
    }

   /* manageHardToken() {
        this.isManagingHardToken = true;
        this.$q
            .resolve(
                !this.companyUser.id && this.hardToken ||
                this.UsersResource.getCompanyUserHardToken(this.companyId, this.companyUser.id)
            )
            .then(token => this.HardTokenService.getDetail(token.id)
                .then(data => Object.assign(token, data)))
            .then((token) => this.HardTokenEditModal(token))
            .finally(() => this.isManagingHardToken = false)
    }*/
    
    manageHardToken(){
	 this.isManagingHardToken = true;
        this.$q
            .resolve(
                !this.companyUser.id && this.hardToken ||
                this.UsersResource.getCompanyUserHardToken(this.companyId, this.companyUser.id)
            )
            .then(token => this.HardTokenService.getDetail(token.id)
                .then(data => Object.assign(token, data)))
            .then((token) => this.$state.go('company.hard-token-management.edit', {token: token,hardTokenId: token.id}))
            .finally(() => this.isManagingHardToken = false)
               
	}

    changeNotificationEmail() {
        this.isSavingNotificationEmail = true;
        this.UsersResource
            .changeNotificationEmail(
                this.companyId,
                this.companyUser.id,
                this.notificationEmailAccount.id,
            )
            .then(() => {
                this.$state.reload();
                this.Alert('success', 'company.user-directories.manage-user.notification-email-changed');
                this.companyUser.userIdentifyingName = this.notificationEmailAccount.username;
            })
            .finally(() => this.isSavingNotificationEmail = false)
    }

    selectedDeletableItems() {
        return this.stAccounts.selectedItems.filter(account => account.isDeletable)
    }

    selectedRemovableItems() {
        return this.stAccounts.selectedItems.filter(account => account.isDisownable)
    }

    showDeleteUserModal() {
        this.$uibModal
            .open({
                component: 'companyUserDirectoriesManageUserDeleteUser',
                resolve: {
                    companyId: () => this.companyId,
                    companyUserId: () => this.companyUser.id,
                },
            }).result
            .then(() => this.$state.go('company.user-directories.saaspass-users'))
            .then(() => this.Alert('success', 'company.user-directories.manage-user.delete-user.deleted'))
    }

	 showBackupcodesModal() {
      /*  this.$uibModal
            .open({
                component: 'companyUserDirectoriesManageUserGenerateBC',
                resolve: {
                    companyId: () => this.companyId,
                    companyUserId: () => this.companyUser.id,
                },
            }).result
            */
            this.$state.go('.backup-codes');
           
    }
    showSmsResetPinModal() {
        this.$uibModal
            .open({
                component: 'companyUserDirectoriesManageUserSmsResetPin',
                resolve: {
                    companyId: () => this.companyId,
                    companyUserId: () => this.companyUser.id,
                },
            }).result
            .then(() => this.$state.go('^'))
            .then(() => this.Alert('success', 'groups_users.company_user_reset_pin_code_sent_success'))
    }

    unblock() {
        this.isUpdatingStatus = true;
        this.UsersResource
            .unblockCompanyUser(this.companyId, this.companyUser.id)
            .then(() => {
                this.companyUser.blocked = 'NONE';
                this.initializeUserStatusFlags();
                this.Alert('success', 'company.user-directories.manage-user.unblocked');
            })
            .finally(() => this.isUpdatingStatus = false)
    }

    pause() {
        this.isUpdatingStatus = true;
        this.UsersResource
            .pauseCompanyUser(this.companyId, this.companyUser.id)
            .then(() => {
                this.companyUser.status = 'PAUSED';
                this.initializeUserStatusFlags();
                this.Alert('success', 'company.user-directories.manage-user.paused');
            })
            .finally(() => this.isUpdatingStatus = false)
    }

    unpause() {
        this.isUpdatingStatus = true;
        this.UsersResource
            .unpauseCompanyUser(this.companyId, this.companyUser.id)
            .then(() => {
                this.companyUser.status = 'ACTIVE';
                this.initializeUserStatusFlags();
                this.Alert('success', 'company.user-directories.manage-user.unpaused');
            })
            .finally(() => this.isUpdatingStatus = false)
    }

    unshareServiceAccount(item) {
        this.ConfirmDeleteModal('groups_users.confirm_shared_email_account_delete')
            .then(() => {
                
                const accountIds = [ item.corporateAccountId ];

                this.isSaving = true;
                this.UsersResource
                    .deleteUserSharedServiceAccounts(this.companyId, this.companyUser.id, accountIds)
                    .then(() => {
                        this.Alert('success', 'company.user-directories.manage-user.shared-accounts.unshared');

                        const companyAccounts = this.accountsForCompanyUser;
                        const notes=this.userSharedNotes;
                        let corporateAccounts;
                        this.UsersResource.getUserSharedServiceAccounts(this.companyId, this.companyUser.id)
                        .then((result) => {
                            this.userSharedServiceAccounts = result;
                            corporateAccounts = this.userSharedServiceAccounts;

                            if (corporateAccounts.length || companyAccounts.length || notes.length ) {
                                this.$state.go('^');
                            } else {
                                // When all accounts are deleted, company user is also deleted
                                this.$state.go('company.user-directories.saaspass-users');
                            }
                        })
                        .catch((response)=>{
                            if(response.data.serviceErrorCode === "ERR_200016"){
                                this.$state.go('company.user-directories.saaspass-users');
                            }
                        });
                    })
                    .finally(() => this.isSaving = false)
            });
    }

    unshareNote(item) {
        this.ConfirmDeleteModal('groups_users.confirm_shared_email_account_delete')
            .then(() => {
                
                const noteIds = [ item.id ];

                this.isSaving = true;
                this.UsersResource
                    .deleteUserSharedNotes(this.companyId, this.companyUser.id, noteIds)
                    .then(() => {
                        this.Alert('success', 'company.user-directories.manage-user.shared-accounts.unshared');

                        const companyAccounts = this.accountsForCompanyUser;
                        const corporateAccounts=this.userSharedServiceAccounts;
                        let notes;
                        this.UsersResource.getUserSharedNotes(this.companyId, this.companyUser.id)
                        .then((result) => {
                            this.userSharedNotes = result;
                            notes = this.userSharedNotes;

                            if (corporateAccounts.length || companyAccounts.length || notes.length ) {
                                this.$state.go('^');
                            } else {
                                // When all accounts are deleted, company user is also deleted
                                this.$state.go('company.user-directories.saaspass-users');
                            }
                        })
                        .catch((response)=>{

                            if(response.data.serviceErrorCode === "ERR_200016"){
                                this.$state.go('company.user-directories.saaspass-users');
                            }
                        });
                    })
                    .finally(() => this.isSaving = false)
            });
    }
}

/** @ngInject */
function hardTokens($filter, HardTokenService) {
    // return HardTokenService.list().then((items) => $filter('orderBy')(items, 'effectiveStatus'));
    return HardTokenService.list().then((items) => items);
}


// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/details/manage-user-details.controller.js